export default function TechStackData() {
  return null;
}

export const techdata = [
  {
    title: "Backend",
    language: ["Node.js", "Express", "Python", "Java", "PHP"],
  },
  {
    title: "DevOps",
    language: ["Docker", "Kubernetes", "Podman "],
  },
  {
    title: "UI/UX  ",
    language: ["Figma ", "Adobe XD", "Sketch ", "InVision "],
  },
  {
    title: "Frontend",
    language: ["React", "React Native", "Next.js", "TailwindCSS"],
  },
];
